import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import logo from '../../images/my_btn_mb_w.png';
import { useAppContext } from 'utils/store';
import { apiWrapper } from 'apis/CommonApi';
import * as fireonApi from "../../apis/FireOnApi";
import { useDaumPostcodePopup } from "react-daum-postcode";

export default function NewFireOnItemComponent(props) {
    let { id } = useParams();
    const navigate = useNavigate();
    const isEdit = typeof id !== 'undefined';
    const [formData, setFormData] = useState(null);
    const [isReadyToCreate, setIsReadyToCreate] = useState(false);
    const [isNotReadyToCreateModalOpen, setIsNotReadyToCreateModalOpen] = useState(false);

    useEffect(() => {
        handleClearFireFightingObject();
        handleClear();

        if (isEdit) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.getFireFightingObjectById(id);
                if (status === true) {
                    setFormDataProperty("serialNumber", data.serialNumber);
                    setFormDataProperty("dei", data.dei);
                    setFormDataProperty("buildingName", data.buildingName);
                    setFormDataProperty("searchAddressText", data.searchAddressText);
                    setFormDataProperty("roadAddress", data.roadAddress);
                    setFormDataProperty("roadAddressDetail", data.roadAddressDetail);
                    setFormDataProperty("groundFloors", data.groundFloors);
                    setFormDataProperty("basementFloors", data.basementFloors);
                    setFormDataProperty("buildingArea", data.buildingArea);
                    setFormDataProperty("totalFloorArea", data.totalFloorArea);
                    setFormDataProperty("floorAreaRatio", data.floorAreaRatio);
                    setFormDataProperty("mainUse", data.mainUse);
                    setFormDataProperty("mainStructure", data.mainStructure);
                    setFormDataProperty("roofStructure", data.roofStructure);
                    setFormDataProperty("completionDate", data.completionDate);
                    setFormDataProperty("approvalDate", data.approvalDate);
                } else {
                    alert(`${data}`);
                }
            })
        }
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormDataProperty(name, value);
    };

    const onTryChange = (e) => {
        if (isEdit === false && isReadyToCreate === false) {
            setIsNotReadyToCreateModalOpen(true);
            setTimeout(() => {
                setIsNotReadyToCreateModalOpen(false);
            }, 3000);
        }
    }

    const handleCompleteAddress = (data) => {
        setFormDataProperty("roadAddress", data.roadAddress);
    };

    const handleSave = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else if (checkValid() === false) {
            e.stopPropagation();
        } else {
            apiWrapper(async () => {
                const requestBody = {
                    serialNumber: formData.serialNumber,
                    dei: formData.dei,
                    buildingName: formData.buildingName,
                    roadAddress: formData.roadAddress,
                    roadAddressDetail: formData.roadAddressDetail,
                    groundFloors: formData.groundFloors,
                    basementFloors: formData.basementFloors,
                    buildingArea: formData.buildingArea,
                    totalFloorArea: formData.totalFloorArea,
                    floorAreaRatio: formData.floorAreaRatio,
                    mainUse: formData.mainUse,
                    mainStructure: formData.mainStructure,
                    roofStructure: formData.roofStructure,
                    completionDate: formData.completionDate,
                    approvalDate: formData.approvalDate,
                };
                let result;

                if (id) {
                    result = await fireonApi.updateFireFightingObject(id, requestBody);
                } else {
                    result = await fireonApi.createFireFightingObject(requestBody);
                }

                const { status, data } = result;
                if (status === true) {
                    alert(`저장을 완료하였습니다.`);

                    //성공 시 뒤로가기
                    navigate(-1);

                    // setIsSaveModalOpen(true);
                    // setTimeout(() => {
                    //     setIsSaveModalOpen(false);
                    // }, 3000);
                } else {
                    alert(`저장을 실패하였습니다.\n${data}`)
                }
            });
        }
    };

    const checkValid = () => {
        //신규등록일 때에는 화재수신기 조회해야 등록 가능
        if (isEdit === false && isReadyToCreate === false) {
            alert(`등록할 화재수신기를 조회해주세요.`);
            return false;
        }
        return true;
    }

    const handleClearFireFightingObject = () => {
        setFormDataProperty("serialNumber", "");
        setFormDataProperty("dei", "");
    }

    const handleClear = () => {
        setFormDataProperty("buildingName", "");
        setFormDataProperty("searchAddressText", "");
        setFormDataProperty("address", "");
        setFormDataProperty("detailAddress", "");
        setFormDataProperty("groundFloors", "");
        setFormDataProperty("basementFloors", "");
        setFormDataProperty("buildingArea", "");
        setFormDataProperty("totalFloorArea", "");
        setFormDataProperty("floorAreaRatio", "");
        setFormDataProperty("mainUse", "");
        setFormDataProperty("mainStructure", "");
        setFormDataProperty("roofStructure", "");
        setFormDataProperty("completionDate", "");
        setFormDataProperty("approvalDate", "");
    }

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="viewBoard fireOnBoard newFireBoard">
                {formData && (
                    <>
                        <TopBoard
                            header={props.header}
                            isEdit={isEdit}
                            handleGoBack={handleGoBack} />
                        <MidBoard
                            isEdit={isEdit}
                            formData={formData}
                            onChange={onChange}
                            setIsReadyToCreate={setIsReadyToCreate}
                            handleClearFireFightingObject={handleClearFireFightingObject}
                            handleClear={handleClear}
                        />
                        <InputBoard
                            isEdit={isEdit}
                            isReadyToCreate={isReadyToCreate}
                            formData={formData}
                            onChange={onChange}
                            onTryChange={onTryChange}
                            handleCompleteAddress={handleCompleteAddress}
                            handleSave={handleSave}
                            handleGoBack={handleGoBack}
                        />
                    </>
                )}
                {
                    isNotReadyToCreateModalOpen && (
                        <div id="modal" className="modal-overlay show">
                            <div className="modal-content infoResultModal">
                                <div className="modal_inner">
                                    <p className="modal_title">화재 수신기를 먼저 조회해 주시기 바랍니다.</p>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        </>
    );
}

const TopBoard = ({ header, isEdit, handleGoBack }) => {
    const location = useLocation();
    const { buildingName } = isEdit ? location.state : '';

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo"> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="">
                            <img src={logo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">{isEdit === false ? `대상물 신규 등록` : buildingName}</p>
                </div>
                {header}
                <div className="wrap_right mb">
                    <div className="wrap_search pc">
                        <div className="box_search">
                            <div className="select_box">
                                <button className="btn_select">
                                    <p>항목</p>
                                    <i className="x-icon"></i>
                                </button>
                                <ul className="list_member">
                                    <li>
                                        <p>1</p>
                                    </li>
                                    <li>
                                        <p>2</p>
                                    </li>
                                    <li>
                                        <p>3</p>
                                    </li>
                                </ul>
                            </div>
                            <input type="text" placeholder="검색어를 입력해주세요." />
                            <button className="btn_search">
                                <i className="x-icon icon_search"></i>
                            </button>
                        </div>
                    </div>
                    <Link className="btn_page_left" to="/new_mb.html">
                        <i className="x-icon"></i>
                    </Link>
                </div>
            </div>
        </>
    );
};

const MidBoard = ({ isEdit, formData, onChange, setIsReadyToCreate, handleClearFireFightingObject, handleClear }) => {
    let { id } = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNoRegisteredModalOpen, setIsNoRegisteredModalOpen] = useState(false);
    const [searchResultMessage, setSearchResultMessage] = useState("");

    const handleSearch = () => {
        const searchSerialNumber = formData.serialNumber;
        const searchDei = formData.dei;

        if (searchSerialNumber === '' || searchDei === '') {
            //alert('화재수신기의 일련번호 및 DEI코드를 입력해주세요.');
            setSearchResultMessage('화재수신기의 일련번호 및 DEI코드를 입력해주세요.');
            openModal();
        } else {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.getFireFightingObject(searchSerialNumber, searchDei);
                if (status === true) {
                    if (data.isCreated) {
                        //alert(`이미 등록된 화재수신기입니다. 다른 화재수신기를 조회해주세요.`);
                        setSearchResultMessage(`이미 등록된 화재수신기입니다. 다른 화재수신기를 조회해주세요.`);
                        openModal();
                    } else {
                        setIsNoRegisteredModalOpen(true);
                    }
                } else {
                    //alert(`${data}`);
                    setSearchResultMessage(`${data}`);
                    openModal();
                }
            })
        }
    };

    const openModal = () => {
        setIsModalOpen(true);
        setTimeout(() => {
            setIsModalOpen(false);
        }, 3000);
    }

    return (
        <>
            <div className="mid_board pc">
                <div className="wrap_mid_le">
                    {isEdit === false && (
                        <div style={{ margin: '10px' }}>
                            <p>☞ 대상물 신규 등록을 하시려면 화재수신기 전면에 부착된 화재수신기 일련번호와 DEI 코드를 입력해 주시기 바랍니다.</p>
                        </div>
                    )}
                    <div className="building_info">
                        {isEdit === false && (
                            <div style={{ margin: '10px', display: 'flex', alignItems: 'center', minWidth: 'fit-content' }}>
                                <p>화재수신기 조회</p>
                            </div>
                        )}
                        <div className="item_info">
                            <p className="txt_info title_info">일련번호</p>
                            <input type="text" placeholder="화재수신기 일련번호를 입력해주세요." name="serialNumber" value={formData.serialNumber} onChange={onChange} required />
                        </div>
                        <div className="item_info">
                            <p className="txt_info title_info">DEI 코드</p>
                            <input type="text" placeholder="화재수신기 DEI 코드를 입력해주세요." name="dei" value={formData.dei} onChange={onChange} required />
                        </div>
                        {isEdit === false && (
                            <button className="btn_search" onClick={handleSearch}>
                                <i className="x-icon icon_search"></i>
                            </button>
                        )}
                    </div>
                    {isEdit && (
                        <div className="wrap_item_contr">
                            <button
                                className="btn_contr btn_new active"
                            >
                                건축물 일반 현황
                            </button>
                            <Link
                                className="btn_contr btn_new"
                                to={`/fire-on/building-detail-status/${id}`}
                                state={{
                                    buildingName: formData.buildingName,
                                    serialNumber: formData.serialNumber,
                                    dei: formData.dei,
                                }}
                            >
                                건축물 상세 현황
                            </Link>
                            <Link
                                className="btn_contr btn_new"
                                to={`/fire-on/building-equipment-status/${id}`}
                                state={{
                                    buildingName: formData.buildingName,
                                    serialNumber: formData.serialNumber,
                                    dei: formData.dei,
                                }}
                            >
                                소방설비 등록 현황
                            </Link>
                            <Link
                                className="btn_contr btn_new"
                                to={`/fire-on/user-status/${id}`}
                                state={{
                                    buildingName: formData.buildingName,
                                    serialNumber: formData.serialNumber,
                                    dei: formData.dei,
                                }}
                            >
                                사용자 등록 현황
                            </Link>
                        </div>
                    )}
                </div>
            </div >

            {isModalOpen && (
                <div className="modal-overlay show" id="modalOverlay">
                    <div className="modal-content infoResultModal">
                        <div className="modal_inner">
                            {searchResultMessage}
                        </div>
                    </div>
                </div>
            )}

            {
                isNoRegisteredModalOpen && (
                    <div id="modal" className="modal darkModal dbmsDelModal show">
                        <div className="modal-content">
                            <div className="modal_inner">
                                <p className="modal_title">등록된 대상물 정보가 없습니다.</p>
                                <p className="modal_sub">대상물을 신규등록하시겠습니까?</p>
                                <div className="btn-wrap">
                                    <button
                                        className="modal_btn prev-btn"
                                        onClick={() => {
                                            setIsNoRegisteredModalOpen(false)
                                            setIsReadyToCreate(false);
                                            handleClearFireFightingObject();
                                        }}>
                                        이전으로</button>
                                    <button
                                        className="modal_btn add_btn"
                                        onClick={() => {
                                            setIsNoRegisteredModalOpen(false);
                                            setIsReadyToCreate(true);
                                            handleClear();
                                        }}>
                                        추가하기
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

const InputBoard = ({ isEdit, isReadyToCreate, formData, onChange, onTryChange, handleCompleteAddress, handleSave, handleGoBack }) => {
    //const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const open = useDaumPostcodePopup();
    const isReadonly = isEdit === false && isReadyToCreate === false;

    const handleCancel = () => {
        setIsCancelModalOpen(true);
    }

    const handleModalCancel = () => {
        setIsCancelModalOpen(false);
    }

    const handleFindAddress = () => {
        let width = 450;
        let height = 540;
        let left = Math.ceil((window.screen.width - width) / 2);
        let top = Math.ceil((window.screen.height - height) / 2);

        open({
            onComplete: handleCompleteAddress,
            defaultQuery: formData.searchAddressText,
            popupKey: "kakaomap1",
            width: width,
            height: height,
            left: left,
            top: top,
        });
    }

    return (
        <>
            <form className="input_board" onSubmit={handleSave}>
                <div className="wrap_inner">
                    <div className="inner_input_board">
                        <div className="input_item">
                            <p className="title_input">건물명칭</p>
                            <div className="wrap_input">
                                <input className="darkInput" type="text" placeholder="건물 명을 입력해주세요." name="buildingName" value={formData.buildingName} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">도로명 주소</p>
                            <div className="wrap_input">
                                <div className="wrap_input_btn">
                                    <input className="darkInput" type="text" placeholder="건물 명을 입력해주세요." name="searchAddressText" value={formData.searchAddressText} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} />
                                    <button type="button" className="btn_input" onClick={handleFindAddress}>검색</button>
                                </div>
                                <input className="darkInput" type="text" placeholder="" name="roadAddress" value={formData.roadAddress} readOnly required />
                                <input className="darkInput" type="text" placeholder="상세주소를 입력해주세요." name="roadAddressDetail" value={formData.roadAddressDetail} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} />
                            </div>
                        </div>
                        <div className="input_item in_title_input">
                            <p className="title_input">건물 층수</p>
                            <div className="wrap_input">
                                <div className="inner_wrap">
                                    <p className="inner_title">지하</p>
                                    <input className="darkInput" type="number" placeholder="몇층인지 입력해주세요." name="basementFloors" value={formData.basementFloors} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                                </div>
                                <div className="inner_wrap">
                                    <p className="inner_title">지상</p>
                                    <input className="darkInput" type="number" placeholder="몇층인지 입력해주세요." name="groundFloors" value={formData.groundFloors} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                                </div>
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">건축 면적</p>
                            <div className="wrap_input">
                                <input className="darkInput" type="text" placeholder="소수점 2자리까지 입력해주세요." pattern="^\d*\.?\d{0,2}$" name="buildingArea" value={formData.buildingArea} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                                <p className="unit">㎡</p>
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">전체 연면적</p>
                            <div className="wrap_input">
                                <input className="darkInput" type="text" placeholder="소수점 2자리까지 입력해주세요." pattern="^\d*\.?\d{0,2}$" name="totalFloorArea" value={formData.totalFloorArea} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                                <p className="unit">㎡</p>
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">용적률</p>
                            <div className="wrap_input">
                                <input className="darkInput" type="text" placeholder="소수점 1자리까지 입력해주세요." pattern="^\d*\.?\d{0,1}$" name="floorAreaRatio" value={formData.floorAreaRatio} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                                <p className="unit">%</p>
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">주용도</p>
                            <div className="wrap_input">
                                <input className="darkInput" type="text" placeholder="주용도를 입력해주세요." name="mainUse" value={formData.mainUse} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">주구조</p>
                            <div className="wrap_input">
                                <input className="darkInput" type="text" placeholder="주구조를 입력해주세요." name="mainStructure" value={formData.mainStructure} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">지붕구조</p>
                            <div className="wrap_input">
                                <input className="darkInput" type="text" placeholder="지붕구조를 입력해주세요." name="roofStructure" value={formData.roofStructure} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">준공일</p>
                            <div className="wrap_input">
                                <div className="detail_box detail_date_box date-wrap">
                                    <div className={`date-input-wrap ${formData.completionDate ? "selected" : ""}`}>
                                        <p class="date-title" style={{ display: formData.completionDate ? "none" : "block" }}>{formData.completionDate || '년-월-일'}</p>
                                        <input type="date" className="darkInput form-input" id="new_date" name="completionDate" value={formData.completionDate} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="input_item">
                            <p className="title_input">사용승인일</p>
                            <div className="wrap_input">
                                <div className="detail_box detail_date_box date-wrap">
                                    <div className={`date-input-wrap ${formData.approvalDate ? "selected" : ""}`}>
                                        <p class="date-title" style={{ display: formData.approvalDate ? "none" : "block" }}>{formData.approvalDate || '년-월-일'}</p>
                                        <input type="date" className="darkInput form-input" id="new_date" name="approvalDate" value={formData.approvalDate} onChange={onChange} onFocus={onTryChange} readOnly={isReadonly} required />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wrap_btn_set">
                    <button type="button" className="btn_set btn_cancle" onClick={handleCancel}>취소</button>
                    <button type="submit" className="btn_set btn_save">저장</button>
                </div>
            </form>

            {/* {isSaveModalOpen && (
                <div class="modal-overlay show" id="modalSaveOverlay">
                    <div class="modal-content addSaveModal">
                        <div class="modal_inner">
                            <p class="title_cont">등록이 완료되었습니다.</p>
                        </div>
                    </div>
                </div>
            )} */}

            {isCancelModalOpen && (
                <div class="modal-overlay show" id="modalCancleOverlay">
                    <div class="modal-content addCancleModal">
                        <div class="modal_inner">
                            <p class="title_cont">정말로 취소하시겠습니까?</p>
                            <p class="sub_cont">취소하시면 작성하신 정보는 사라집니다.</p>
                            <div class="btn_modal_wrap">
                                <button class="btn_modal btn_goBack" onClick={handleGoBack}>예</button>
                                <button class="btn_modal btn_cancle" onClick={handleModalCancel}>아니오</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};